import React, { ReactElement } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Grid, Box } from '@material-ui/core'
import EmailIcon from '@material-ui/icons/Email'
import CallRoundedIcon from '@material-ui/icons/CallRounded'
import Container from '@material-ui/core/Container'
import Divider from '@material-ui/core/Divider'
import * as HelpInfo from '@src/routes/Configurators/utils/HelpInfo.json'
import { FormattedMessage } from 'react-intl'
import YouTubeIcon from '@material-ui/icons/YouTube'
import ConfiguratorVideoTutorial from '@src/routes/Configurators/components/ConfiguratorVideoTutorial'

const useStyles = makeStyles((theme: Theme) => {
  return {
    icon: {
      marginRight: theme.spacing(1),
      color: theme.palette.primary.main,
      float: 'left',
    },
    HelpWrapper: {
      padding: 0,
    },
    item: {
      marginBottom: theme.spacing(1.5),
      '& >div': {
        fontWeight: 700,
      },
    },
    divider: {
      margin: theme.spacing(1, 0, 5, 0),
      height: theme.spacing(1),
      color: theme.palette.primary.main,
    },
    heading: {
      marginBottom: theme.spacing(1),
      fontSize: theme.typography.pxToRem(22),
      fontWeight: theme.typography.fontWeightRegular,
    },
    helpText: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
    },
    helpLink: {
      color: theme.palette.primary.main,
      marginLeft: theme.spacing(6.25),
      wordBreak: 'break-word',
    },
  }
})

const HelpNav = (props) => {
  const classes = useStyles()
  const { country, product } = props

  const defaultEmail = 'custsvc@milliporesigma.com'
  const defaultPhone = '1-800-234-5362'
  const email = () => {
    if (HelpInfo[`CONF_EMAIL_ADDRESS_${country}_${product}`]) {
      return HelpInfo[`CONF_EMAIL_ADDRESS_${country}_${product}`]
    } else {
      if (HelpInfo[`CONF_EMAIL_ADDRESS_${country}_default`]) {
        return HelpInfo[`CONF_EMAIL_ADDRESS_${country}_default`]
      } else {
        return defaultEmail
      }
    }
  }
  const phoneNumber = () => {
    if (HelpInfo[`CONF_TEL_${country}_${product}`]) {
      return HelpInfo[`CONF_TEL_${country}_${product}`]
    } else {
      if (HelpInfo[`CONF_TEL_${country}_default`]) {
        return HelpInfo[`CONF_TEL_${country}_default`]
      }
      return defaultPhone
    }
  }
  const insertVideoLink = (link: ReactElement) => {
    return (
      <Grid container justifyContent="flex-end" direction="row">
        <Grid item xs={12} className={classes.item}>
          <YouTubeIcon className={classes.icon} fontSize="small" />
          {link}
        </Grid>
      </Grid>
    )
  }

  return (
    <Box mt={50}>
      <Container className={classes.HelpWrapper}>
        <h3 className={classes.heading}>
          <FormattedMessage id="HELP" defaultMessage="Help" />
        </h3>
        <div>
          <Divider color="primary" className={classes.divider} />{' '}
        </div>
        <ConfiguratorVideoTutorial insertVideoLink={insertVideoLink} />

        <Grid container justify="flex-end" direction="row">
          <Grid item xs={12} className={classes.item}>
            <EmailIcon className={classes.icon} fontSize="small" />
            <a href={`mailto:${email()}`}>
              <h4 className={clsx(classes.helpText, classes.helpLink)}>
                {email()}
              </h4>
            </a>
          </Grid>
        </Grid>
        <Grid container justify="flex-end" direction="row">
          <Grid item xs={12} className={classes.item}>
            <div>
              <CallRoundedIcon className={classes.icon} fontSize="small" />
              <h4 className={classes.helpText}>{phoneNumber()}</h4>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default HelpNav
